module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_DE.66581d5f.txt";